<script lang="ts">
  import translationsStore from '../../../stores/translations.svelte'
  import componentAttributesStore from '../../../stores/componentAttributes.svelte'
  import videoStore from '../../../stores/video.svelte'
  import withPreventDefault from '../../../utils/withPreventDefault'
  import PauseIcon from '../icons/PauseIcon.svelte'
  import PlayFullIcon from '../icons/PlayFullIcon.svelte'
  import PlayIcon from '../icons/PlayIcon.svelte'
  import ReplayIcon from '../icons/ReplayIcon.svelte'
  import { THEMES, COLORS } from '../../../const/themes'

  const onClick = (e: MouseEvent) =>
    withPreventDefault(e, () => {
      videoStore.state.videoController.togglePlayPause()
    })
</script>

<!-- svelte-ignore a11y_mouse_events_have_key_events -->

{#if !videoStore.state.hasPlaybackStarted && !componentAttributesStore.state.autoplay && videoStore.state.mediaDescriptor?.mediaType !== 'live'}
  <button
    class="w-14 h-14 z-10 relative"
    aria-label={translationsStore.state.play}
    onclick={(e) => onClick(e)}
  >
    <span
      class="w-8 h-8 rounded-lg absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-0"
      style={`background-color: ${COLORS.LIGHT}`}
    ></span>
    <span
      class="z-10 relative"
      style="fill: {componentAttributesStore.state.playButtonColor ||
        componentAttributesStore.state.primaryColor ||
        THEMES.DEFAULT.PLAY_BUTTON_COLOR};"
    >
      <PlayFullIcon />
    </span>
  </button>
{:else if videoStore.state.isMobileLayout}
  <button
    class="w-14 h-14 z-10 relative"
    style="fill: {componentAttributesStore.state.buttonsColor ||
      THEMES.DEFAULT.BUTTONS_COLOR};"
    aria-label={videoStore.state.isPlaying ? 'Pause (space)' : 'Play (space)'}
    onclick={(e) => onClick(e)}
  >
    {#if videoStore.state.isEnded}
      <ReplayIcon />
    {:else if videoStore.state.isPlaying}
      <PauseIcon />
    {:else}
      <PlayIcon />
    {/if}
  </button>
{/if}
